import React, { useEffect, useState } from "react";
import { Users, BookOpen, IndianRupee, ShoppingBag, Clock, Star, GraduationCap, TrendingUp } from "lucide-react";
import api from "@/lib/api";
import { StatCard, Money, Badge } from "@/components/common";

export default function AdminDashboard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/dashboard").then(({ data }) => setD(data)); }, []);
  if (!d) return null;
  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-heading text-3xl font-bold text-navy mb-8">Admin Dashboard</h1>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 mb-6">
        <StatCard label="Total Users" value={d.total_users} icon={Users} testid="stat-users" />
        <StatCard label="Learners" value={d.learners} icon={GraduationCap} accent="bg-emerald-600" />
        <StatCard label="Educators" value={d.educators} icon={GraduationCap} accent="bg-amber" />
        <StatCard label="Content Sellers" value={d.sellers} icon={TrendingUp} accent="bg-crimson" />
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 mb-6">
        <StatCard label="Courses" value={d.courses} icon={BookOpen} />
        <StatCard label="Published" value={d.published_courses} icon={BookOpen} accent="bg-emerald-600" />
        <StatCard label="Pending Approvals" value={d.pending_approvals} icon={Clock} accent="bg-amber" testid="stat-pending" />
        <StatCard label="Pending Reviews" value={d.pending_reviews} icon={Star} accent="bg-crimson" />
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 mb-10">
        <StatCard label="Revenue" value={<Money amount={d.revenue} />} icon={IndianRupee} accent="bg-navy" testid="stat-revenue" />
        <StatCard label="Commission Paid" value={<Money amount={d.commission} />} icon={IndianRupee} accent="bg-amber" />
        <StatCard label="Orders" value={d.orders} icon={ShoppingBag} />
        <StatCard label="Tests" value={d.tests} icon={BookOpen} accent="bg-emerald-600" />
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <div className="bg-white border border-border rounded-lg p-6">
          <h2 className="font-heading font-bold text-navy mb-4">Recent Registrations</h2>
          <div className="space-y-3">
            {d.recent_registrations.map((u) => (
              <div key={u.id} className="flex items-center justify-between text-sm">
                <div className="flex items-center gap-3"><div className="h-8 w-8 rounded-full viriks-navy text-amber flex items-center justify-center font-bold text-xs">{u.name?.[0]}</div><span className="font-medium">{u.name}</span></div>
                <Badge tone="gray">{u.role?.replace("_", " ")}</Badge>
              </div>
            ))}
          </div>
        </div>
        <div className="bg-white border border-border rounded-lg p-6">
          <h2 className="font-heading font-bold text-navy mb-4">Recent Orders</h2>
          <div className="space-y-3">
            {d.recent_orders.length === 0 && <p className="text-sm text-muted-foreground">No orders yet.</p>}
            {d.recent_orders.map((o) => (
              <div key={o.id} className="flex items-center justify-between text-sm">
                <span className="font-medium">#{o.order_no} — {o.user_name}</span>
                <Money amount={o.total} className="font-semibold" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
